import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders dialog overlays at document.body so the scrim covers the whole
 * window — including the sidebar — no matter where in the screen tree the
 * sheet component happens to mount (CommentsSheet and ClaimSheet live
 * inside their screens, not at the root layout). React context flows
 * through portals, so theme/stores keep working.
 */
export function DialogPortal({ children }: { children: React.ReactNode }) {
  if (typeof document === 'undefined') return <>{children}</>;
  return createPortal(children, document.body);
}
